/**
 * The pieces every /well-testing screen draws the same way.
 *
 * IMPORTED, not copied: the register, chips, badge, panel, field and input are
 * the NDT screens' (which import the downhole ones), so the verticals stay one
 * shape. Nothing in those files is edited by this vertical.
 */
export {
  NdtBadge as WtBadge,
  NdtChip as WtChip,
  NdtChipRow as WtChipRow,
  NdtDialog as WtDialog,
  NdtEmpty as WtEmpty,
  NdtField as WtField,
  NdtFormError as WtFormError,
  NdtLoading as WtLoading,
  NdtPanel as WtPanel,
  NdtRegister as WtRegister,
  NdtSpec as WtSpec,
  NDT_INPUT as WT_INPUT,
  NDT_DATE_INPUT as WT_DATE_INPUT,
  NDT_PRIMARY as WT_PRIMARY,
  NDT_SECONDARY as WT_SECONDARY,
  isNotFound,
  type NdtColumn as WtColumn,
} from '../ndt-inspection/NdtBits';
export { DH_BAND_SECONDARY as WT_BAND_SECONDARY } from '../downhole/DownholeBits';

export const WT_EYEBROW = 'Well testing';

/**
 * A well has no status, so its register rail claims no colour (the rule for a
 * value the register cannot classify). Sour is a FLAG, drawn as a red badge in
 * its own column, not as a status rail.
 */
export const WT_RAIL = 'border-l-transparent';
export const WT_SOUR_SKIN = { label: 'Sour', fill: 'bg-fi-signal-red', rail: 'border-l-transparent' };
